import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  heading: {
    marginRight: theme.spacing(2),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
}))

export default useStyles
